require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/es7.symbol.observable.js
// module id = 422
// module chunks = 0